module.exports = __webpack_public_path__ + "img/clogo.747945df.png";